import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { Modal, Form, Input, message } from 'antd';
import { userAPI } from '../services/api';
import { createGuestUser, isGuestUser } from '../utils/guestUser';
import './HomePage.css';

// 九型体质详细数据（根据《吾调九型体质详细资料整合》更新）
const bodyTypesData = [
  {
    name: '平和质',
    icon: '☯',
    description: '平和质是人人称羡慕的整体健康状态，表现为精力充沛，身体脏腑功能状态比较稳定，适应能力强。这类人群在饮食、起居、运动等方面都有较强的适应能力，不易生病。',
    features: [
      '阴阳气血调和，体态适中面色红润，精力充沛',
      '体形匀称健壮，面色、肤色润泽',
      '头发稠密有光泽，目光有神',
      '不易疲劳，耐受寒热，睡眠良好',
      '二便正常，舌色淡红，苔薄白，脉和缓有力',
      '性格随和开朗，患病较少，适应力强'
    ],
    判断标准: [
      '舌诊：舌淡红苔薄白，脉和缓有力',
      '面诊：面色红润有光泽，肤质细腻',
      '体态：体型匀称，不胖不瘦，体态适中',
      '精神：精神饱满，精力充沛，反应敏捷'
    ],
    commonIssues: [
      '受现代生活方式影响，平和质人群比例在下降',
      '需注意保持规律作息和健康饮食，保持平和',
      '避免过度劳累和情绪波动，均衡饮食适度运动',
      '定期体检，预防疾病，达成均衡营养'
    ],
    soupInfo: {
      name: '①山药芡实黄精臻润汤(平和体质汤)',
      ingredients: '和元汤汤方料包+药食同源辅料（珍珠、阿胶、枸杞子、山药、红枣）',
      principle: '低剂量、食药同源、协同增效，旨在通过日常饮食，达成均衡营养',
      image: '/images/soups/平和质.png'
    }
  },
  {
    name: '气虚质',
    icon: '🌾',
    description: '气虚质的人常感到疲倦乏力，话说多了气虚，只爬三四层楼会气喘吁吁，而且还容易出汗，容易感冒。起居方面注意规律作息，避免熬夜；运动上可选择慢跑、太极拳等较柔和的运动方式。',
    features: [
      '元气不足，疲乏气短肌肉松软，容易出汗',
      '容易疲乏，气短懒言，语声低怯',
      '容易感冒，病后恢复缓慢',
      '舌淡红，舌体胖大，边有齿痕，脉弱',
      '不耐受寒邪、风邪、暑邪',
      '性格内向，情绪不稳定'
    ],
    判断标准: [
      '舌诊：舌质淡红或淡白，舌体胖大，边有齿痕，舌苔胖有齿痕，脉弱',
      '面诊：面色偏黄或苍白，目光少神',
      '症状：容易疲劳，气短乏力，话说多了气虚',
      '体质：肌肉松软不实，爬楼梯会气喘吁吁'
    ],
    commonIssues: [
      '容易患感冒及内脏下垂等病',
      '病后康复缓慢，抵抗力弱',
      '不耐受风邪、寒邪、暑邪',
      '需注重补气养气，增强体质，避免过度劳累'
    ],
    soupInfo: {
      name: '②白术乌梅山药舒和汤(气虚体质汤)',
      ingredients: '补气汤汤方料包（三七、红花、大枣、黄芪、枸杞子）',
      principle: '低剂量、食药同源、协同增效，旨在通过日常饮食，达成均衡',
      image: '/images/soups/气虚质.png'
    }
  },
  {
    name: '阳虚质',
    icon: '❄️',
    description: '阳虚质的人常感手脚冰冷，畏寒怕冷，有严重的人甚至在夏天都要穿上毛衣或棉衣。起居上注意保暖，避免受凉；运动上可选择快走、登山等运动量稍大的运动方式。',
    features: [
      '阳气不足，畏寒怕冷手足不温，喜热饮食',
      '畏寒怕冷，手足不温，精神不振',
      '舌淡胖嫩，苔白滑，脉沉迟',
      '大便溏薄，小便清长，面色柔白',
      '目胞晦暗，性格多沉静、内向',
      '甚至在夏天都要穿上毛衣或棉衣'
    ],
    判断标准: [
      '舌诊：舌质淡胖嫩，舌苔白滑或白腻，脉沉迟',
      '面诊：面色苍白或青白，唇色淡，目胞晦暗',
      '症状：畏寒怕冷，手足冰凉，喜热饮食',
      '体温：四肢偏凉，喜暖怕寒，精神不振'
    ],
    commonIssues: [
      '容易患感冒、腹泻等病',
      '易患关节疼痛、骨质疏松',
      '女性易痛经、月经不调',
      '需注重温阳散寒，避免受凉，注意保暖'
    ],
    soupInfo: {
      name: '③肉苁蓉覆盆子虚逆汤(阳虚体质汤)',
      ingredients: '温阳散寒汤汤方料包（山药、黄芪、枸杞子、桂圆、熟地黄）',
      principle: '温补肾阳，散寒暖身，低剂量、食药同源、协同增效',
      image: '/images/soups/阳虚质.png'
    }
  },
  {
    name: '阴虚质',
    icon: '🔥',
    description: '阴虚质的人常感到口干舌燥，易上火，有时候会心里感觉炽热，脾气也急躁。核心特征是阴液亏少，口干咽燥手足心热，大便干燥。',
    features: [
      '阴液亏少，口干咽燥手足心热，大便干燥',
      '手足心热，口燥咽干，喜冷饮',
      '舌红少津，苔少或无苔，脉细数',
      '面色潮红，眼干涩，眩晕耳鸣',
      '睡眠差，性情急躁，外向好动',
      '有时候会心里感觉炽热，脾气急躁'
    ],
    判断标准: [
      '舌诊：舌红少津，苔少或无苔，脉细数',
      '面诊：面色潮红，颧部尤甚，眼干涩',
      '症状：手足心热，口干咽燥，大便干燥',
      '体感：怕热喜凉，盗汗，睡眠差'
    ],
    commonIssues: [
      '容易失眠、便秘，易患虚劳',
      '易患干燥综合征，失精',
      '皮肤干燥，容易长斑',
      '需注重滋阴降火，避免燥热伤阴，避免熬夜'
    ],
    soupInfo: {
      name: '④黄精黄芪柔润汤(阴虚体质汤)',
      ingredients: '润燥汤汤方料包（山药、黄芪、枸杞子、桂圆、熟地黄）',
      principle: '滋阴润燥，清热养阴，低剂量、食药同源、协同增效',
      image: '/images/soups/阴虚质.png'
    }
  },
  {
    name: '痰湿质',
    icon: '💧',
    description: '痰湿质的人常感到身体沉重，舌苔厚腻，身体肥胖。核心特征是痰湿凝聚，形体肥胖面部油腻，口黏苔腻。',
    features: [
      '痰湿凝聚，形体肥胖面部油腻，口黏苔腻',
      '体形肥胖，腹部肥满松软，面部皮肤油脂较多',
      '容易出汗，汗液黏腻，口黏腻或甜，痰多',
      '舌体胖大，苔白腻或黄腻，脉滑',
      '身体沉重，性格偏温和，稳重',
      '舌苔厚腻，身体肥胖'
    ],
    判断标准: [
      '舌诊：舌体胖大，舌苔白腻或黄腻，脉滑',
      '面诊：面色淡黄晦暗，面部油腻，口黏苔腻',
      '体态：体形肥胖，腹部肥满，身体沉重',
      '症状：身重困倦，痰多，容易出汗'
    ],
    commonIssues: [
      '易患糖尿病、中风、胸痹等',
      '易患高血压、高血脂、冠心病',
      '易患脂肪肝、代谢综合征',
      '需注重化痰祛湿，健脾利湿，控制体重'
    ],
    soupInfo: {
      name: '⑤茯苓莲子清畅汤(痰湿体质汤)',
      ingredients: '祛湿汤汤方料包（艾叶、茯苓、益母草、防己、莲子）',
      principle: '健脾化痰，祛湿消脂，低剂量、食药同源、协同增效',
      image: '/images/soups/痰湿质.png'
    }
  },
  {
    name: '湿热质',
    icon: '🌡️',
    description: '湿热质的人常感到口干口苦，易长痘，大便不畅，偏爱吃辣。核心特征是湿热内蕴，面垢油光口苦口干，大便黏滞。',
    features: [
      '湿热内蕴，面垢油光口苦口干，大便黏滞',
      '面部和鼻部油光发亮，易生痤疮粉刺',
      '口苦口干，身重困倦，大便黏滞不爽',
      '小便短黄，男易阴囊潮湿，女易带下增多',
      '舌质偏红苔黄腻，脉滑数，性情急躁易怒',
      '易长痘，大便不畅，偏爱吃辣'
    ],
    判断标准: [
      '舌诊：舌质偏红，舌苔黄腻，脉滑数',
      '面诊：面部油腻，易生痤疮，面垢油光',
      '症状：口苦口干，身重困倦，大便黏滞',
      '二便：大便黏滞，小便短黄，带下增多'
    ],
    commonIssues: [
      '易患痤疮、湿疹等皮肤病',
      '易患泌尿系统感染、黄疸',
      '易患肝胆疾病、热淋等',
      '需注重清热利湿，避免湿热环境，清淡饮食'
    ],
    soupInfo: {
      name: '⑥百合桔红畅舒汤(湿热体质汤)',
      ingredients: '清利汤汤方料包（川贝、百合、白果、白雪梨、黄精）',
      principle: '清热利湿，解毒祛湿，低剂量、食药同源、协同增效',
      image: '/images/soups/湿热质.png'
    }
  },
  {
    name: '血瘀质',
    icon: '🩸',
    description: '体内有血液运行不畅的潜在倾向或瘀血内阻的病理基础，以血瘀表现为主要特征的体质状态。核心特征是血行不畅，肤色晦暗易出瘀斑，口唇暗淡。',
    features: [
      '血行不畅，肤色晦暗易出瘀斑，口唇暗淡',
      '肤色晦暗或色素沉着，容易出现瘀斑',
      '口唇暗淡，舌质暗或有瘀点，舌下络脉紫暗',
      '易健忘，注意力不集中，脉涩',
      '女性多见痛经，闭经，性情急躁，易烦',
      '体内有血液运行不畅的潜在倾向'
    ],
    判断标准: [
      '舌诊：舌质暗或有瘀点、瘀斑，舌下络脉紫暗，脉涩',
      '面诊：面色晦暗，口唇色暗，肤色晦暗',
      '皮肤：易有色斑、瘀斑，易出瘀斑',
      '疼痛：身体某处常有固定疼痛，女性痛经闭经'
    ],
    commonIssues: [
      '易患心脑血管病、中风、胸痹等',
      '易患肿瘤类疾病',
      '女性易患妇科疾病、痛经闭经',
      '需注重活血化瘀，避免久坐不动，通络止痛'
    ],
    soupInfo: {
      name: '⑦参芪石斛醇养汤(血瘀体质汤)',
      ingredients: '血虚活络汤汤包（黄芪、人参、黄精、红枣、桂圆）',
      principle: '活血通络，止痛止痛，低剂量、食药同源、协同增效',
      image: '/images/soups/血瘀质.png'
    }
  },
  {
    name: '气郁质',
    icon: '😔',
    description: '由于长期情志不畅、气机郁滞而形成的以性格内向不稳定、忧郁脆弱、敏感多疑为主要表现的体质状态。核心特征是气机郁滞，情志抑郁胸胁胀满，忧虑脆弱。',
    features: [
      '气机郁滞，情志抑郁胸胁胀满，忧虑脆弱',
      '神情抑郁，情绪低落，忧虑脆弱，敏感多疑',
      '胸胁胀满，或走窜疼痛，善太息（叹气）',
      '咽喉部异物感，舌淡红苔薄白，脉弦',
      '性格内向不稳定，敏感多虑',
      '忧郁脆弱，敏感多疑，情志抑郁'
    ],
    判断标准: [
      '舌诊：舌质淡红或偏暗，苔薄白，脉弦',
      '面诊：神情抑郁，愁眉不展，情绪低落',
      '情绪：情绪低落，易焦虑，忧虑脆弱',
      '症状：胸闷胁胀，善叹息，咽喉异物感'
    ],
    commonIssues: [
      '易患抑郁症、焦虑症、脏燥不寐等',
      '易患乳腺增生、功能性胃肠病',
      '易患失眠症、情绪障碍',
      '需注重疏肝解郁，保持心情舒畅，调畅情志'
    ],
    soupInfo: {
      name: '⑧酸枣仁菊花舒和汤(气郁体质汤)',
      ingredients: '疏肝解郁汤料包（佛手、玫瑰花、柴胡、香附、陈皮）',
      principle: '疏肝理气，解郁安神，低剂量、食药同源、协同增效',
      image: '/images/soups/气郁质.png'
    }
  },
  {
    name: '特禀质',
    icon: '🌸',
    description: '由于先天禀赋不足和禀赋遗传等因素造成的一种特殊体质。包括先天性、遗传性的生理缺陷与疾病，过敏反应等。核心特征是过敏反应，先天异常生理缺陷，遗传疾病。',
    features: [
      '过敏反应，先天异常生理缺陷，遗传疾病',
      '易过敏（对药物、食物、气味等），适应能力差',
      '易患哮喘、荨麻疹等，皮肤易起风团、瘙痒',
      '鼻塞、打喷嚏、流涕，舌质因人而异',
      '对环境适应能力差，易感外邪',
      '先天禀赋不足，有家族遗传倾向'
    ],
    判断标准: [
      '病史：有过敏史、家族遗传史，先天异常',
      '症状：易过敏，反复发作，适应能力差',
      '体质：对环境适应能力差，易感外邪',
      '表现：因人而异，因过敏原而异，遗传疾病'
    ],
    commonIssues: [
      '易患过敏性疾病，哮喘、荨麻疹',
      '易患哮喘、鼻炎、花粉症等',
      '易患荨麻疹、湿疹等皮肤病',
      '需注重益气固表，避免接触过敏原，增强体质'
    ],
    soupInfo: {
      name: '⑨党参当归优养汤(特禀体质汤)',
      ingredients: '固本汤料包（佛手、党参、红枣、黄精、人参）',
      principle: '益气固表，增强体质，低剂量、食药同源、协同增效',
      image: '/images/soups/特禀质.png'
    }
  }
];

const HomePage = ({ currentUser, setCurrentUser }) => {
  const navigate = useNavigate();
  const [loginModalVisible, setLoginModalVisible] = useState(false);
  const [bodyTypeModalVisible, setBodyTypeModalVisible] = useState(false);
  const [selectedBodyType, setSelectedBodyType] = useState(null);
  const [form] = Form.useForm();
  const bodyTypeModalRef = useRef(null);

  const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8080';

  // 检查URL参数，如果从其他页面点击"立即注册"跳转过来，自动打开注册弹窗
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.get('action') === 'register' && isGuestUser(currentUser)) {
      setLoginModalVisible(true);
      // 清除URL参数
      window.history.replaceState({}, '', window.location.pathname);
    }
  }, [currentUser]);

  // 监听体质详情弹窗打开，重置滚动位置
  useEffect(() => {
    if (bodyTypeModalVisible) {
      // 等待Modal完全渲染后重置滚动位置
      const timer = setTimeout(() => {
        const modalBody = document.querySelector('.body-type-modal .ant-modal-body');
        if (modalBody) {
          modalBody.scrollTop = 0;
        }
      }, 100);

      return () => clearTimeout(timer);
    }
  }, [bodyTypeModalVisible]);

  // 处理弹窗关闭事件
  const handleBodyTypeModalClose = () => {
    setBodyTypeModalVisible(false);
    setSelectedBodyType(null);
    // 确保滚动位置重置
    setTimeout(() => {
      const modalBody = document.querySelector('.body-type-modal .ant-modal-body');
      if (modalBody) {
        modalBody.scrollTop = 0;
      }
    }, 0);
  };

  // 处理开始检测（未登录时显示选择框）
  const handleStartDetection = () => {
    if (currentUser) {
      navigate('/detection');
    } else {
      // 弹出登录Modal，用户可以选择登录或游客模式
      setLoginModalVisible(true);
    }
  };

  // 游客体验
  const handleGuestMode = () => {
    const guestUser = createGuestUser();
    setCurrentUser(guestUser);
    message.success('已进入游客模式，体验结束后可随时注册保存数据！');
    navigate('/detection');
  };

  // 查看历史报告
  const handleViewHistory = () => {
    if (currentUser) {
      navigate('/history');
    } else {
      setLoginModalVisible(true);
    }
  };

  // 处理登录/注册
  const handleLogin = async (values) => {
    try {
      const response = await userAPI.createUser(values);
      const user = response.data.user;
      setCurrentUser(user);
      
      // 如果之前是游客，提示升级成功
      if (isGuestUser(currentUser)) {
        message.success('注册成功！您的账号已创建，数据将永久保存');
      } else {
        message.success('登录成功！');
      }
      
      setLoginModalVisible(false);
      // 如果当前在首页，不自动跳转
      if (window.location.pathname === '/') {
        // 停留在首页，让用户自己选择
      } else {
        navigate('/detection');
      }
    } catch (error) {
      message.error('登录失败，请重试');
    }
  };

  // 处理体质卡片点击
  const handleBodyTypeClick = (bodyType) => {
    setSelectedBodyType(bodyType);
    setBodyTypeModalVisible(true);
  };

  return (
    <div className="container">
      <div className="page-wrapper home-page">
        <div className="logo-section">
          <h1 className="page-title">吾调九型体质检测</h1>
          <p className="subtitle">传统中医·现代科技·健康养生</p>
        </div>

        {currentUser && (
          <div className="user-info-section">
            <div className={`welcome-banner ${isGuestUser(currentUser) ? 'guest-banner' : ''}`}>
              <div className="welcome-content">
                <div className="welcome-icon">👋</div>
                <div className="welcome-text">
                  <div className="welcome-title">欢迎回来</div>
                  <div className="welcome-name">{currentUser.name}</div>
                </div>
                {isGuestUser(currentUser) && (
                  <span className="guest-badge">游客模式</span>
                )}
              </div>
              {isGuestUser(currentUser) && (
                <button
                  className="upgrade-button"
                  onClick={() => setLoginModalVisible(true)}
                >
                  注册账号
                </button>
              )}
            </div>
          </div>
        )}

        <div className="section">
          <h2 className="section-title">检测须知</h2>
          <div className="section-content">
            <ul className="notice-list">
              <li>请在光线充足的环境下拍摄照片</li>
              <li>拍摄舌诊照片时，请自然伸出舌头，保持舌面平整</li>
              <li>拍摄面诊照片时，请保持面部清晰，表情自然</li>
              <li>请确保照片清晰，无遮挡物</li>
              <li>检测结果仅供参考，如有疑问请咨询专业医师</li>
            </ul>
          </div>
        </div>

        <div className="section">
          <h2 className="section-title">九型体质介绍</h2>
          <div className="section-content">
            <p>
              九种体质是中医学对人体体质特征的分类理论，由平和体质与八种亚健康体质构成，源于中医典籍并融合气候、饮食、情志等因素分析个体差异。平和体质表现为阴阳调和、体态适中，其余八类包括阳虚、阴虚、气虚、痰湿、湿热、血瘀、气郁及特禀体质，分别对应畏寒怕冷、口燥咽干、疲乏气短等典型症状。现代中医以王琦院士的体质辨识法为核心，将其纳入“治未病”工程，形成标准化分类体系。
              该理论起源于《黄帝内经》等经典，经后世医家逐步完善。2009年《中医体质分类与判定》标准发布，确立九种体质的辨识规范。调理方法涵盖饮食调整（如阳虚体质避寒温补）、运动养生（如痰湿体质加强有氧锻炼）及起居调摄，并衍生食疗产品辅助体质干预。体质分类现为中医临床诊疗与健康管理的重要参考依据。
            </p>
            <div className="body-type-list">
              {bodyTypesData.map((bodyType, index) => (
                <div 
                  key={index}
                  className="body-type-item"
                  onClick={() => handleBodyTypeClick(bodyType)}
                >
                  <span className="body-type-icon">{bodyType.icon}</span>
                  <span>{bodyType.name}</span>
                </div>
              ))}
            </div>
            <p style={{ marginTop: '16px', textAlign: 'center', color: '#8b7355', fontSize: '13px' }}>
              点击体质卡片可查看详细介绍
            </p>
          </div>
        </div>

        <div className="section">
          <h2 className="section-title">吾调九型体质汤介绍</h2>
          <div className="section-content">
            <p>
              吾调九型体质汤是根据中医"食补"理念研发的养生汤底系列产品。
              我们精选道地药材，遵循传统炮制工艺，针对不同体质特点，研制出九款专属养生汤品。
            </p>
            <div className="soup-features">
              <div className="feature-item">
                <div className="feature-icon">🏺</div>
                <div className="feature-text">非遗技艺</div>
              </div>
              <div className="feature-item">
                <div className="feature-icon">🔬</div>
                <div className="feature-text">科技赋能</div>
              </div>
              <div className="feature-item">
                <div className="feature-icon">🛡️</div>
                <div className="feature-text">安全守护</div>
              </div>
              <div className="feature-item">
                <div className="feature-icon">❤️</div>
                <div className="feature-text">全民健康</div>
              </div>
            </div>
            <div className="brand-intro">
              <h4>品牌介绍</h4>
              <p><strong>吾调 · 千年药膳传承者</strong></p>
              <p>吾调，源自北宋御医尹吾调创立的宫廷药膳体系，融合《黄帝内经》阴阳五行理论与现代营养科学，以"医食同源，寓药于食"为核心理念，打造无药味、易吸收、安全有效的现代药膳汤品。</p>

              <h4>品牌核心价值</h4>
              <ul>
                <li><strong>非遗技艺：</strong>传统御医秘方，获非物质文化遗产认证</li>
                <li><strong>科技赋能：</strong>现代生物提纯技术，去除苦味，保留药效</li>
                <li><strong>安全守护：</strong>降解农残激素，食材本味放大，色香味俱全</li>
                <li><strong>全民健康：</strong>从"治已病"转向"治未病"，提升国民体质</li>
              </ul>
            </div>
            <p style={{ marginTop: '16px' }}>
              每款汤品都经过专业中医师精心配伍，确保药食同源，安全有效。
              定期饮用，可以调理体质，增强免疫力，达到养生保健的目的。
            </p>
          </div>
        </div>

        <div className="button-group">
          <button className="button-primary" onClick={handleStartDetection}>
            {currentUser ? '开始检测' : '开始检测'}
          </button>
          {currentUser && (
            <button className="button-secondary" onClick={handleViewHistory}>
              查看历史报告
            </button>
          )}
        </div>

        {/* 登录/注册 Modal */}
        <Modal
          title={isGuestUser(currentUser) ? "注册账号" : "登录/注册"}
          open={loginModalVisible}
          onCancel={() => setLoginModalVisible(false)}
          footer={null}
          width={480}
        >
          {isGuestUser(currentUser) && (
            <div style={{
              background: 'linear-gradient(135deg, #fff9e6 0%, #fff5d6 100%)',
              padding: '12px 16px',
              borderRadius: '2px',
              border: '1px solid rgba(212, 165, 116, 0.3)',
              marginBottom: '16px',
              fontSize: '13px',
              color: '#6d5a4a',
              lineHeight: '1.8'
            }}>
              💡 注册账号后，您的检测数据将永久保存，可在任何设备上查看
            </div>
          )}
          <Form form={form} onFinish={handleLogin} layout="vertical">
            <Form.Item
              label="姓名"
              name="name"
              rules={[{ required: true, message: '请输入您的姓名' }]}
            >
              <Input placeholder="请输入姓名" />
            </Form.Item>
            <Form.Item
              label="手机号"
              name="phone"
              rules={[
                { required: true, message: '请输入手机号' },
                { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号' }
              ]}
            >
              <Input placeholder="请输入手机号" />
            </Form.Item>
            <Form.Item>
              <button type="submit" className="button-primary" style={{ width: '100%' }}>
                {isGuestUser(currentUser) ? '立即注册' : '注册并开始检测'}
              </button>
            </Form.Item>
          </Form>

          {/* 仅非游客用户显示游客选项 */}
          {!isGuestUser(currentUser) && (
            <>
              {/* 游客选项分隔线 */}
              <div style={{
                display: 'flex',
                alignItems: 'center',
                margin: '20px 0',
                color: '#8b7355',
                fontSize: '13px'
              }}>
                <div style={{ flex: 1, height: '1px', background: 'rgba(139, 115, 85, 0.3)' }}></div>
                <span style={{ padding: '0 12px', letterSpacing: '2px' }}>或</span>
                <div style={{ flex: 1, height: '1px', background: 'rgba(139, 115, 85, 0.3)' }}></div>
              </div>

              {/* 游客体验选项 */}
              <div style={{
                background: 'linear-gradient(135deg, #fff9e6 0%, #fff5d6 100%)',
                padding: '16px',
                borderRadius: '2px',
                border: '1px solid rgba(212, 165, 116, 0.3)',
                marginBottom: '12px'
              }}>
                <p style={{
                  color: '#6d5a4a',
                  fontSize: '13px',
                  lineHeight: '1.8',
                  margin: '0 0 12px 0',
                  fontFamily: '"STSong", "SimSun", "宋体", serif'
                }}>
                  💡 不想注册？可以<strong style={{ color: '#b8860b' }}>游客体验</strong>，报告会临时保存在浏览器中
                </p>
                <button 
                  className="button-secondary guest-button" 
                  onClick={() => {
                    setLoginModalVisible(false);
                    handleGuestMode();
                  }}
                  style={{ width: '100%' }}
                >
                  游客体验（无需注册）
                </button>
              </div>

              <p style={{
                color: '#8b7355',
                fontSize: '12px',
                textAlign: 'center',
                margin: '8px 0 0 0',
                lineHeight: '1.6'
              }}>
                ⚠️ 游客模式：数据临时保存，建议注册以永久保存
              </p>
            </>
          )}
        </Modal>

        {/* 体质详情 Modal */}
        <Modal
          title={
            <div className="body-type-modal-title">
              <span className="body-type-modal-icon">{selectedBodyType?.icon}</span>
              <span>{selectedBodyType?.name}</span>
            </div>
          }
          open={bodyTypeModalVisible}
          onCancel={handleBodyTypeModalClose}
          footer={null}
          width={680}
          className="body-type-modal"
        >
          {selectedBodyType && (
            <div className="body-type-detail">
              <div className="detail-section">
                <h3 className="detail-section-title">体质概述</h3>
                <p className="detail-description">{selectedBodyType.description}</p>
              </div>

              <div className="detail-section">
                <h3 className="detail-section-title">主要特征</h3>
                <ul className="detail-list">
                  {selectedBodyType.features.map((feature, index) => (
                    <li key={index}>{feature}</li>
                  ))}
                </ul>
              </div>

              <div className="detail-section">
                <h3 className="detail-section-title">诊断标准</h3>
                <ul className="detail-list diagnostic-list">
                  {selectedBodyType.判断标准.map((standard, index) => (
                    <li key={index}>{standard}</li>
                  ))}
                </ul>
              </div>

              <div className="detail-section">
                <h3 className="detail-section-title warning-title">易发问题</h3>
                <ul className="detail-list warning-list">
                  {selectedBodyType.commonIssues.map((issue, index) => (
                    <li key={index}>{issue}</li>
                  ))}
                </ul>
              </div>

              <div className="detail-footer">
                {selectedBodyType.soupInfo && (
                  <div className="soup-recommendation">
                    <h4 className="soup-title">推荐汤品</h4>
                    <div className="soup-info">
                      {selectedBodyType.soupInfo.image && (
                        <div className="soup-image-container">
                          <img
                            src={selectedBodyType.soupInfo.image}
                            alt={selectedBodyType.soupInfo.name}
                            className="soup-image"
                          />
                        </div>
                      )}
                      <div className="soup-details">
                        <h5 className="soup-name">{selectedBodyType.soupInfo.name}</h5>
                        <p className="soup-ingredients">
                          <strong>主要成分：</strong> {selectedBodyType.soupInfo.ingredients}
                        </p>
                        <p className="soup-principle">
                          <strong>设计原则：</strong> {selectedBodyType.soupInfo.principle}
                        </p>
                      </div>
                    </div>
                  </div>
                )}
                <p className="detail-tip">
                  💡 想知道您的体质类型吗？点击下方按钮开始检测！
                </p>
                <button
                  className="button-primary"
                  onClick={() => {
                    handleBodyTypeModalClose();
                    handleStartDetection();
                  }}
                >
                  立即检测我的体质
                </button>
              </div>
            </div>
          )}
        </Modal>
      </div>
    </div>
  );
};

export default HomePage;

